import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { BrandGroup } from 'types'

import {
    CerebroApiOptionsHeaders,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from '../types'

export const createBrandGroup = (
    data: any
): Promise<CerebroResourceResponse<BrandGroup>> =>
    orgScopedApiClient.post('/api/brand_groups/', data)

export const getBrandGroups = (
    params: Record<string, unknown>,
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroPaginatedResponse<BrandGroup>> =>
    orgScopedApiClient.get(`/api/brand_groups/`, {
        params,
        headers: getCerebroHeaders(options.headers),
    })
addCache(getBrandGroups)

export const updateBrandGroup = (
    brandGroupId: string,
    data: Record<string, unknown>
): Promise<CerebroResourceResponse<BrandGroup>> =>
    orgScopedApiClient.patch(`/api/brand_group/${brandGroupId}/`, data)

export const deleteBrandGroup = (
    brandGroupId: string
): Promise<CerebroResourceResponse<void>> =>
    orgScopedApiClient.delete(`/api/brand_group/${brandGroupId}/`)
